<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">{{ $t('rtr_personal-asset-account.text1') }}</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-account.text2') }}<br />
				{{ $t('rtr_personal-asset-account.text3') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area left tac">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-asset-account.text4') }}<br />
							{{ $t('rtr_personal-asset-account.text5') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_personal-asset-account.text6') }}<br />
							{{ $t('rtr_personal-asset-account.text7') }}<br />
							{{ $t('rtr_personal-asset-account.text8') }}
						</p>
					</div>
				</div>

				<div class="bg_box mb_16">
					<div class="bg_text_area right tac">
						<p class="text_t">{{ $t('rtr_personal-asset-account.text9') }}</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-account.text10') }}<br />
							{{ $t('rtr_personal-asset-account.text11') }}
						</p>
					</div>
				</div>

				<div class="bg_box border_r_16">
					<div class="bg_text_area center tac">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-asset-account.text12') }}<br />
							{{ $t('rtr_personal-asset-account.text13') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Account',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
